import dayjs from "../../../../utils/dayjs-util";
import { useFetchSubscriptionThroughputHistoryQuery } from "../../../../queries/subscription-throughput-queries";
import AverageMonthlyPerformance from "./AverageMonthlyPerformance";
import AverageMonthlyImprovement from "./AverageMonthlyImprovement";

const MonthlyPerformanceCards = ({ subscriptionId }) => {

    // Australia 00:00 for the previous day
    const aestTimeFrom = dayjs().tz("Australia/Melbourne").subtract(1, "day").startOf("day");

    // Australia 00:00 for the current day
    const aestTimeTo = dayjs().tz("Australia/Melbourne").startOf("day");

    // Convert these start of days' to UTC format for API requests
    const dateTimeFrom = aestTimeFrom.utc().format("YYYY-MM-DDTHH:mm:ss"); // 2x days ago 14:00+00:00
    const dateTimeTo = aestTimeTo.utc().format("YYYY-MM-DDTHH:mm:ss"); // 1x day ago 14:00+00:00

    const period = "monthly";
    const throughputHistory = useFetchSubscriptionThroughputHistoryQuery(subscriptionId, period, dateTimeFrom, dateTimeTo);

    return (
        <div className="performance-cards-container">
            <AverageMonthlyImprovement throughputHistory={throughputHistory} />
            <AverageMonthlyPerformance throughputHistory={throughputHistory} />
        </div>
    );
};

export default MonthlyPerformanceCards;